import BaseApiPageableCollection from "scripts/collections/baseApiPageableCollection";
import MediaCollectionHoc from "scripts/hoc/mediaCollectionHoc";
import HybridCollectionHoc from "scripts/hoc/hybridCollectionHoc";

class FacetedSearchResultCollection extends HybridCollectionHoc(
  MediaCollectionHoc(BaseApiPageableCollection),
) {
  parse(response, options) {
    this.facets = response.facets;
    this.searchTime = response.searchTime;

    return super.parse(response.media, options);
  }
}

export default FacetedSearchResultCollection;
